import { useCallback } from 'react';

import { sumLedgerTotal } from '@order/features/ordering';
import { type OrderingContext } from '@order/features/ordering';
import {
  formatBagForAnalytics,
  formatCustomerPersonalInfo,
  googleAnalytics,
} from '@order/Telemetry';

import { useSnapPixel } from '../../../../integrations';

export const usePostOrderTracking = () => {
  const { trackPurchase: trackSnapPixelPurchase } = useSnapPixel();

  const handlePostOrderTracking = useCallback(
    ({ context }: { context: OrderingContext }) => {
      const {
        orderId = '',
        cart,
        selectedTip,
        availableCredit,
        shouldUseCredit,
      } = context;

      const { lineItems, ledger } = cart;

      const { total } = sumLedgerTotal(
        ledger,
        selectedTip,
        availableCredit,
        shouldUseCredit,
      );

      trackSnapPixelPurchase({
        priceInDollars: total / 100,
        orderId,
        productIds: lineItems?.map((item) => item.product?.id ?? '') ?? [],
        lineItemsQuantity: lineItems?.length ?? 0,
      });

      googleAnalytics.track({
        event: 'purchase',
        userId: context?.customer?.customerId,
        transaction_id: context?.orderId,
        new_customer: context?.customer?.isNewCustomer,
        ...formatBagForAnalytics(context),
        ...formatCustomerPersonalInfo(context),
      });
    },
    [trackSnapPixelPurchase],
  );

  // ─────────────────────────────────────────────────────────────────────

  return { handlePostOrderTracking };
};
